import * as go from 'gojs';

export const highlightPredecessors = (node: go.Node): void => {
  highlightTree(
    node,
    (n: go.Node) => n.findLinksInto(),
    (n: go.Node) => n.findNodesInto(),
  );
};

export const highlightAncestors = (node: go.Node): void => {
  highlightTree(
    node,
    (n: go.Node) => n.findLinksOutOf(),
    (n: go.Node) => n.findNodesOutOf(),
  );
};

const highlightTree = (
  node: go.Node,
  linksCallback: (node: go.Node) => go.Iterator<go.Link>,
  nodesCallback: (node: go.Node) => go.Iterator<go.Node>,
): void => {
  const stack: go.Set<go.Node> = new go.Set([node]);
  const it = stack.iterator;
  const used = new Set<go.Key>();

  while (it.next()) {
    const currentNode = it.value;

    if (!currentNode || used.has(currentNode.key)) {
      continue;
    }
    used.add(currentNode.key);

    currentNode.isHighlighted = true;
    linksCallback(currentNode).each((l: go.Link) => (l.isHighlighted = true));
    stack.addAll(nodesCallback(currentNode));
  }
};
